import React, { Suspense } from 'react';
import { Route, Switch } from 'react-router-dom';

// components
import { PermissionRoute } from './permission-route';
import { BookingListPage } from 'pages/booking/list';
import { PathCreator, RoutePaths } from './constants';
import { lazyWithRetry } from 'utils/lazy-with-reload';
import { GlobalLayout } from 'components/layout/global';
import { GlobalSuspense } from 'components/suspense/global-suspense';
import { BookingSuspense } from 'components/suspense/booking-suspense';

// dynamic loading pages
const ContactUsPage = lazyWithRetry(() => import('pages/contact-us'));
const PrivacyPolicyPage = lazyWithRetry(() => import('pages/privacy-policy'));
const DynamicPricingPage = lazyWithRetry(() => import('pages/dynamic-pricing'));
const BookingDetailsPage = lazyWithRetry(() => import('pages/booking/booking-details-page'));
const BookingCheckoutPage = lazyWithRetry(() => import('pages/booking/booking-checkout-page'));
const BookingConfirmationPage = lazyWithRetry(() => import('pages/booking/booking-confirmation-page'));
const ProfilePage = lazyWithRetry(() => import('pages/auth/profile-page/member-profile-page'));
const ProfileBookingsPage = lazyWithRetry(() => import('pages/auth/profile-page/booking-page'));
const WaitlistPage = lazyWithRetry(() => import('pages/auth/profile-page/waitlist-page'));
const ProfileOffersPage = lazyWithRetry(() => import('pages/auth/profile-page/offers-page'));
const BookingCancellationPage = lazyWithRetry(() => import('pages/booking/booking-cancellation'));

export const PublicRoutes = () => (
  <GlobalLayout>
    <Suspense fallback={<GlobalSuspense />}>
      <Switch>
        <PermissionRoute path={PathCreator[RoutePaths.PROFILE].path} component={ProfilePage} exact auth />
        <PermissionRoute
          path={PathCreator[RoutePaths.PROFILE_BOOKINGS].path}
          component={ProfileBookingsPage}
          exact
          auth
        />
        <PermissionRoute path={PathCreator[RoutePaths.PROFILE_WAITLIST].path} component={WaitlistPage} exact auth />
        <PermissionRoute path={PathCreator[RoutePaths.PROFILE_OFFERS].path} component={ProfileOffersPage} exact auth />

        <Route
          path={PathCreator[RoutePaths.BOOKING_LIST].path}
          component={() => (
            <Suspense fallback={<BookingSuspense />}>
              <Switch>
                <PermissionRoute
                  path={PathCreator[RoutePaths.BOOKING_DETAILS].path}
                  component={BookingDetailsPage}
                  exact
                />
                <PermissionRoute
                  path={PathCreator[RoutePaths.BOOKING_CHECKOUT].path}
                  component={BookingCheckoutPage}
                  exact
                />
                <PermissionRoute
                  path={PathCreator[RoutePaths.BOOKING_CONFIRMATION].path}
                  component={BookingConfirmationPage}
                  exact
                />

                <PermissionRoute
                  path={PathCreator[RoutePaths.DYNAMIC_PRICING].path}
                  component={DynamicPricingPage}
                  exact
                />
                <PermissionRoute path={PathCreator[RoutePaths.CONTACT_US].path} component={ContactUsPage} exact />
                <PermissionRoute
                  path={PathCreator[RoutePaths.PRIVACY_POLICY].path}
                  component={PrivacyPolicyPage}
                  exact
                />
                <PermissionRoute
                  path={PathCreator[RoutePaths.BOOKING_CANCELLATION].path}
                  component={BookingCancellationPage}
                  exact
                />

                <PermissionRoute path={PathCreator[RoutePaths.BOOKING_LIST].path} component={BookingListPage} />
              </Switch>
            </Suspense>
          )}
        />
      </Switch>
    </Suspense>
  </GlobalLayout>
);

export default PublicRoutes;

